import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

// Inline element styling for assistant markdown; block-level rules (tables,
// lists, pre-wrap counter-rules) live in the shared chat Bubble styles.
const markdownComponents: React.ComponentProps<typeof ReactMarkdown>['components'] = {
  // Chat links open in a new tab by default — navigating the current tab would
  // tear down the side panel (and any in-progress turn) mid-conversation.
  a: ({ children, href }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
  p: ({ children }) => <p style={{ margin: '0 0 0.5em' }}>{children}</p>,
  ul: ({ children }) => <ul style={{ margin: 0, paddingLeft: 18 }}>{children}</ul>,
  ol: ({ children }) => <ol style={{ margin: '0 0 0.5em', paddingLeft: 18 }}>{children}</ol>,
  h1: ({ children }) => <h3 style={{ margin: '0.4em 0 0.3em', fontSize: '1em' }}>{children}</h3>,
  h2: ({ children }) => <h3 style={{ margin: '0.4em 0 0.3em', fontSize: '1em' }}>{children}</h3>,
  h3: ({ children }) => <h3 style={{ margin: '0.4em 0 0.3em', fontSize: '1em' }}>{children}</h3>,
  code: ({ children }) => (
    <code style={{ fontFamily: 'ui-monospace, SFMono-Regular, monospace', fontSize: '0.9em' }}>
      {children}
    </code>
  ),
}

export const AssistantContent = ({ text }: { text: string }) => (
  <ReactMarkdown components={markdownComponents} remarkPlugins={[remarkGfm]}>
    {text}
  </ReactMarkdown>
)
